import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { G, Mask, Path, Rect } from "react-native-svg";

const SvgNo = (props: SvgProps) => (
  <Svg width={22} height={16} fill="none" {...props}>
    <Rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <Mask
      id="no-flag"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <Rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </Mask>
    <G mask="url(#no-flag)">
      <Path
        fill="#F14247"
        d="M0 9.6h6.286V16H0zM22 16H9.429V9.6H22zM6.286 0v6.4H0V0zM22 6.4H9.429V0H22z"
      />
      <Path
        fill="#0A3A85"
        fillRule="evenodd"
        d="M0 8.533h7.333V16h1.048V8.533H22V7.467H8.38V0H7.334v7.467H0z"
        clipRule="evenodd"
      />
    </G>
  </Svg>
);
const Memo = memo(SvgNo);
export default Memo;
